let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k5dg2")).then(() => parcelRequire('2idLo'));